import React from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useMatch } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import UsersIcon from "../Icons/UsersIcon";

const useStyles = makeStyles()((theme) => ({
  icon: {
    width: 24,
    height: 24,
  },
  listItem: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  listItemIcon: {
    color: colors.gray,
  },
  listItemText: {
    color: colors.dark,
  },
  chevron: {
    color: colors.dark,
    minWidth: 0,
  },
  activeLink: {
    color: theme.palette.primary.main,
    "& .MuiListItemIcon-root": {
      color: "inherit",
    },
    "& .MuiListItemText-root": {
      color: "inherit",
    },
  },
}));

interface Props {
  onClick?: () => void;
}

const ListItemClient: React.FC<Props> = ({ onClick }) => {
  const { classes } = useStyles();

  const match = useMatch("/clients");

  return (
    <li>
      <ListItem
        className={`${classes.listItem} ${match && classes.activeLink}`}
        button
        onClick={onClick}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <UsersIcon />
        </ListItemIcon>
        <ListItemText
          className={classes.listItemText}
          primary={
            <Box
              fontWeight={600}
              fontSize={16}
              lineHeight={1}
              letterSpacing={-0.5}
            >
              Client
            </Box>
          }
        />
        <ListItemIcon className={classes.chevron}>
          <ChevronRightIcon />
        </ListItemIcon>
      </ListItem>
    </li>
  );
};

export default ListItemClient;
